import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=466be6cb&scoped=true&"
import script from "./StatusList.vue?vue&type=script&lang=js&"
export * from "./StatusList.vue?vue&type=script&lang=js&"
import style0 from "./StatusList.vue?vue&type=style&index=0&id=466be6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466be6cb",
  null
  
)

export default component.exports